export default __webpack_public_path__ + "static/media/organization.a01007f7.svg";